import * as React from 'react';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { useTranslation } from "react-i18next";
import DriverEarning from './DriverEarning';
import Earningreports from './Earningreports';
import FleetAdminEarning from './FleetAdminEarning';
import PrivateBookingReports from './PrivateBookingReports';
import { useSelector } from "react-redux";
import { makeStyles} from '@mui/styles';
import { MAIN_COLOR, SECONDORY_COLOR, FONT_FAMILY, labelText } from "../common/sharedFunctions";
import { Typography } from '@mui/material';
import { PageHeader, StatusBadge, SurfaceCard } from "../components/adminPrimitives";
import adminTokens from "../styles/adminDesignTokens";
const useStyles = makeStyles({
  tabs: {

    "& .MuiTabs-indicator": {
      backgroundColor: SECONDORY_COLOR,
      height: 3,
    },
    "& .MuiTab-root.Mui-selected": {
      color: MAIN_COLOR
    }
  },
  typography:{
    fontFamily:FONT_FAMILY
  }
})

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <div>{children}</div>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

export default function AllReports() {
  const [value, setValue] = React.useState(0);
  const { t } = useTranslation();
  const auth = useSelector(state => state.auth);
  const classes =useStyles();

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const role = auth.profile.usertype;
  const reportTabs = [
    {
      label: t('driver_earning'),
      component: <DriverEarning />,
      roles: ['admin', 'fleetadmin']
    },
    {
      label: t('earning_reports'),
      component: <Earningreports />,
      roles: ['admin']
    },
    {
      label: t('fleetadmin_earning_reports'),
      component: <FleetAdminEarning />,
      roles: ['admin']
    },
    {
      label: labelText(t, 'private_booking_commission_report', 'Private Booking Commission Report'),
      component: <PrivateBookingReports reportType="commission" />,
      roles: ['admin']
    },
    {
      label: labelText(t, 'private_booking_fleet_earnings_report', 'Private Booking Fleet Admin Earnings'),
      component: <PrivateBookingReports reportType="fleetEarnings" />,
      roles: ['admin', 'fleetadmin']
    }
  ].filter((tab) => tab.roles.indexOf(role) !== -1);

  return (
    <Box className="garahex-finance-reports-page" sx={{ width: '100%' }}>
      <PageHeader
        eyebrow={labelText(t, "finance", "Finance")}
        title={labelText(t, "reports", "Reports")}
        description={labelText(t, "finance_reports_description", "Review the existing earnings, commission, and private booking report views without changing report calculations.")}
        actions={<StatusBadge tone="info">{`${reportTabs.length} ${labelText(t, "reports", "reports")}`}</StatusBadge>}
      />
      <SurfaceCard sx={{ p: 0, overflow: "hidden" }}>
      <Box sx={{ borderBottom: `1px solid ${adminTokens.colors.border}`, px: 1.5, pt: 1.5 }}>
        <Tabs value={value} onChange={handleChange} aria-label="Finance reports tabs" className={classes.tabs} variant="scrollable">
          {reportTabs.map((tab, index) => (
            <Tab
              key={tab.label}
              style={{marginRight:"20px", minHeight: 52, fontWeight: 900}}
              label={<Typography className={classes.typography}>{tab.label}</Typography>}
              {...a11yProps(index)}
            />
          ))}
        </Tabs>
      </Box>
        {reportTabs.map((tab, index) => (
          <TabPanel key={tab.label} value={value} index={index}>
            {tab.component}
          </TabPanel>
        ))}
      </SurfaceCard>
    </Box>
  );
}
